import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionDateItemRequest,
  CvSectionDate,
  CvSectionDateItem,
  CvSectionDateItemResponse,
  CvSectionDateResponse,
} from '@/../gen';

export const namespace = 'cvSectionDateItemNew';
const actionCreator = actionCreatorFactory(namespace);

export const GetCvSectionDate = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_DATE');
export const SetCvSectionDate = actionCreator<CvSectionDateResponse>(
  'SET_CV_SECTION_DATE'
);
export const SetCvSectionDateItem = actionCreator<CvSectionDateItemResponse>(
  'SET_CV_SECTION_DATE_ITEM'
);
export const CreateCvSectionDateItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_date_id: number;
  };
  body: CreateCvSectionDateItemRequest;
}>('CREATE_CV_SECTION_DATE_ITEM');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionDate: CvSectionDate;
  cvSectionDateItem: CvSectionDateItem;
}

const initialState = (): State => {
  return {
    cvSectionDate: null,
    cvSectionDateItem: null,
  };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionDate, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionDate(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionDate(data.data));
    }),
    action(CreateCvSectionDateItem, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionDateItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_date_id,
        action.payload.body
      );
      context.commit(SetCvSectionDateItem(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionDate, (state, action) => {
      state.cvSectionDate = action.payload?.attributes;
    }),
    mutation(SetCvSectionDateItem, (state, action) => {
      state.cvSectionDateItem = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionDate: state => state.cvSectionDate,
    cvSectionDateItem: state => state.cvSectionDateItem,
  },
};
